<template>
    <div>
        <div style="margin-bottom: 20px">
            <Uploader v-model="form.img"></Uploader>
        </div>
        <!-- <el-button v-if="permission('cpgl_cpsy_plgx')" type="primary">批量更新</el-button> -->
        <el-button v-if="permission('cpgl_cpsy_th')" type="primary" @click="update">替换</el-button>
    </div>
</template>

<script>
import { detail, edit } from "@/api/product/watermark";
import Uploader from "@/components/Uploader";
import listMixin from "@/mixins/list";
export default {
    components: { Uploader },
    data() {
        return {
            form: {
                img: "",
            },
        };
    },
    mixins: [listMixin],
    mounted() {
        this.getDetail();
    },
    methods: {
        getDetail() {
            detail(this.$route.query).then(({ code, result, error }) => {
                if (code === 200) {
                    this.form.img = result.value;
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        update() {
            edit(this.form).then(({ code, error }) => {
                if (code === 200) {
                    this.$message.success("更新成功");
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>

<style></style>
